// extracted by mini-css-extract-plugin
export default {"loader":"pageloader_loader__GBKTt","page-2":"pageloader_page-2__KCbmR","page-3":"pageloader_page-3__1JTAm","page-4":"pageloader_page-4__56UsU","page-5":"pageloader_page-5__xxoi9"};